module.exports = __webpack_public_path__ + "static/media/configurationsIcons.fe83b4f5.svg";